import React, { useEffect } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { useImagesContext } from '../../../contexts/ImagesContext';
import { PlayEngine } from './PlayEngine';

export const STONE_STATE = {
  NORMAL: 0,
  ACTIVE: 1,
  CAPTURED: 2,
  TERRITORY: 3,
};

const COLOR = {
  NONE: null,
  PLAYER: 'B',
  BOSS: 'W',
};

const BoardCell = ({
  vertex,
  stone,
  bossStoneName,
  handlePlayerStonePlace,
  rowIndex,
  colIndex,
}) => {
  const { images } = useImagesContext();

  const bossStoneImageName = bossStoneName + '.png';
  let stoneImg = null;
  if (stone && stone.state === STONE_STATE.ACTIVE) {
    stoneImg =
      stone.color === COLOR.PLAYER
        ? images['play-stone-player-active.png']
        : images[`${bossStoneName}-active.png`];
  } else if (
    stone &&
    stone.state === STONE_STATE.NORMAL &&
    stone.color === COLOR.PLAYER
  ) {
    stoneImg = images['play-stone-player.png'];
  } else if (
    stone &&
    stone.state === STONE_STATE.NORMAL &&
    stone.color === COLOR.BOSS
  ) {
    stoneImg = images[bossStoneImageName];
  } else if (
    stone &&
    stone.state === STONE_STATE.TERRITORY &&
    stone.color === COLOR.PLAYER
  ) {
    stoneImg = images['play-player-territory.png'];
  } else if (
    stone &&
    stone.state === STONE_STATE.TERRITORY &&
    stone.color === COLOR.BOSS
  ) {
    stoneImg = images['play-boss-territory.png'];
  }

  return (
    <BlockCell
      key={`BlockCell_${vertex}`}
      onClick={() => {
        handlePlayerStonePlace(vertex);
      }}
      $row={rowIndex}
      $col={colIndex}
    >
      {stoneImg && <StoneImg src={stoneImg} />}
      {stone && stone.state === STONE_STATE.CAPTURED && (
        <CapturedOverlay src={images['play-captured-stone.png']} />
      )}
    </BlockCell>
  );
};

const CapturedOverlay = styled.img`
  position: absolute;
  bottom: 0;
  left: -50px;
  // display: block;
  z-index: 3;
  // left: 50%;
  // botom: 0;
  // transform: translate(-50%, 0%);
  // overflow: invisible;
`;

const PlayBoard = ({ stageNumber, stones, handlePlayerStonePlace }) => {
  const size = 9;
  const bossStoneName = `play-stone-boss-${stageNumber}`;

  const getStone = (vertex) => {
    return stones.find((s) => s.vertex === vertex);
  };

  const renderBoard = () => {
    console.debug('Render PlayBoard 1');
    console.debug('renderBoard.stones=', stones);
    const board = [];
    for (let row = size - 1; row >= 0; row--) {
      for (let col = 0; col < size; col++) {
        const vertex = PlayEngine.xyToVertex(row, col);
        const stone = getStone(vertex);
        board.push(
          <BoardCell
            // key={`block-${stoneVertex}`}
            vertex={vertex}
            stone={stone}
            rowIndex={row}
            colIndex={col}
            bossStoneName={bossStoneName}
            handlePlayerStonePlace={handlePlayerStonePlace}
          />
        );
      }
    }
    return board;
  };

  return (
    // <div style={{ position: 'relative', textAlign: 'center' }}>
    <StyledBoard $size={size}>{renderBoard()}</StyledBoard>
    // </div>
  );
};

// const StyledBoard = styled.div`
//   position: relative;
//   display: grid;
//   grid-template-columns: repeat(${(props) => props.$size}, 1fr);
//   grid-template-rows: repeat(${(props) => props.$size}, 1fr);
//   border: 1px solid black;
//   gap: 6px;
//   top: 70px;
//   left: 492px;
// `;

// const BlockCell = styled.div`
//   position: relative;
//   grid-column: ${(props) => props.$col};
//   grid-row: ${(props) => props.$row};
//   border: 1px solid yellow;
//   width: 98px;
//   height: 98px;
//   text-align: center;
//   align-content: center;
// `;

const StyledBoard = styled.div`
  position: absolute;
  top: 70px;
  left: 492px;
  width: ${(props) => props.$size * 104}px;
  height: ${(props) => props.$size * 104}px;
`;

const BlockCell = styled.div`
  position: absolute;
  box-sizing: border-box;
  width: 100px;
  height: 100px;
  // border: 1px solid yellow;
  top: ${(props) => props.$row * 104}px;
  left: ${(props) => props.$col * 104}px;
  text-align: center;
  align-content: center;
`;

const StoneImg = styled.img`
  // position: absolute;
  // top: 0;
  //   display: block;
  //   z-index: 2;
  //   top: 50%;
  //   left: 50%;
  //   transform: translate(-50%, -50%);
`;

// const mapStateToProps = ({ hatchEgg }) => ({
//   stones: hatchEgg.stones,
// });

// export default connect(mapStateToProps, null)(PlayBoard);
export default PlayBoard;
